interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-card rounded-xl border border-border p-5 transition-colors
        ${onClick ? 'cursor-pointer hover:border-border-active' : ''}
        ${className}`}
    >
      {children}
    </div>
  );
}
